export default "__VITE_ASSET__rVXdWBp0__"